module.exports = __webpack_public_path__ + "static/img/huanzhe4.13cd1701.webp";